/** Записи сделки — ровно то, что отдаёт `GET /api/deals/{id}/zapis`. */
import { apiFetch } from "@/lib/api";

/** Расчёт слота салона на час (`dealZapisSlotData`), уже плоский. */
export type ZapisSlot = {
  status: number | null;
  load: number | null;
  stylists: number | null;
  avg: boolean;
  cur: number | null;
  prev: number | null;
  zapas: number | null;
  full_optimal: number | null;
  full_prev: number | null;
  full_max: number | null;
  top: boolean;
};

export type ZapisLevel = "none" | "ok" | "orange" | "red";

export type ZapisVerdict = {
  level: ZapisLevel;
  top: boolean;
  violation: boolean;
  reasons: string[];
  status_name: string | null;
};

type Base = { deal_id: number; at: string; user_id: number | null; user: string | null };

export type ZapisEvent =
  | (Base & { kind: "stage"; old: string | null; new: string | null; to_wait: boolean })
  | (Base & {
      kind: "book" | "followup" | "clear";
      old: string | null;
      new: string | null;
      stage: string | null;
      /** Почему не запись: вне часов салона или не «ждем клиента». */
      reason: string | null;
      /** "whatsapp" — правка ушла в Bitrix и вернулась (окно WhatsApp «след. обработка»). */
      source: "whatsapp" | null;
      /** Местное время салона не в Москве. */
      new_local: string | null;
      location_id: number | null;
      location: string | null;
      hour: string | null;
      category: string | null;
      before: ZapisSlot | null;
      after: ZapisSlot | null;
      verdict: ZapisVerdict;
    });

export type DealZapis = {
  deal_id: number;
  total: { bookings: number; violations: number; no_data: number };
  events: ZapisEvent[];
  rules: { id: number; url: string }[];
};

export function loadDealZapis(id: number): Promise<DealZapis> {
  return apiFetch<DealZapis>(`/api/deals/${id}/zapis`);
}
